import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

type GraphicAreaRootProps = HTMLAttributes<HTMLDivElement>

export function GraphicAreaRoot(props: GraphicAreaRootProps) {
  return (
    <div
      {...props}
      className={twMerge(
        'h-full',
        'overflow-y-hidden',
        'flex flex-col bg-white rounded-xl shadow-sm py-5 pl-5',
        props.className,
      )}
    />
  )
}
